import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Service for notifying modals about domain (business rule) exceptions.
 */
@Injectable({
  providedIn: 'root',
})
export class DomainErrorService {
  readonly error = new Subject<string>();

  setError(error: string): void {
    this.error.next(error);
  }
}
